<div #popup class=" no-select mat-dialog-edition-form mat-dialog" appDraggable>
    <div class="popup-header d-flex justify-content-between align-items-center">
      <h2 class="title mx-auto text-center w-100 fs-6">
  
        {{ isNew ? ('SETTINGS.NEW_COMPANY' | translate) : ('SETTINGS.MODIFY_COMPANY'
        |
        translate) }}
  
      </h2>
      <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
        (click)="onClose()"></button>
    </div>

      <!-- CONTENT -->
  <div class="popup-content">
    <form class="form" [formGroup]="form!" (ngSubmit)="onSubmit()" id="ngForm">

      <!-- ROW 1 -->
      <div class="d-flex">
        <div class="row-item-width-50 input-container">
          <label class="input-label">{{ 'SETTINGS.NAME' | translate }}</label>
          <input class="input-field" id="name" placeholder="{{ 'SETTINGS.NAME' | translate }}" formControlName="name" name="name" type="text" />
          @if(form?.get('name')?.invalid && form?.get('name')?.touched){
          <div class="input-errors">
            @if(form?.get('name')?.errors?.['required']){
            <span>{{ 'SETTINGS.NAME_REQUIRED' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="managingOrganizationId">{{ 'SETTINGS.ORGANISATION' | translate }}</label>
              
              <ng-select
                name="managingOrganizationId"
                id="managingOrganizationId"
                [items]="organizations"
                bindLabel="name"
                bindValue="orgId"
                formControlName="managingOrganizationId"
                [multiple]="false"
                [closeOnSelect]="true"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.ORGANISATION' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('managingOrganizationId')?.invalid && form?.get('managingOrganizationId')?.touched) {
                <div class="input-errors">
                  @if (form?.get('managingOrganizationId')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.ORGANIZATION_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div>
          
      </div>
       <!-- ROW 2 -->
       <div class="d-flex">
        <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="countryId">{{ 'SETTINGS.COUNTRY' | translate }}</label>
              
              <ng-select
                name="countryId"
                id="countryId"
                [items]="countries"
                bindLabel="nomEn"
                bindValue="paysId"
                formControlName="countryId"
                [multiple]="false"
                [closeOnSelect]="true"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.COUNTRY' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('countryId')?.invalid && form?.get('countryId')?.touched) {
                <div class="input-errors">
                  @if (form?.get('countryId')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.COUNTRY_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div>

        <!-- <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="admins">{{ 'SETTINGS.ADMINS_AREAS' | translate }}</label>
              
              <ng-select
                name="admins"
                id="admins"
                [items]="organizations"
                bindLabel="name"
                bindValue="id"
                formControlName="admins"
                [multiple]="true"
                [closeOnSelect]="false"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.ADMINS_AREAS' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('admins')?.invalid && form?.get('admins')?.touched) {
                <div class="input-errors">
                  @if (form?.get('admins')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.ADMINS_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div> -->
          
      </div> 
    
    </form>
    </div>
    <div class="popup-footer">
        <button class="secondary-button popup-secondary-button" (click)="onClose()">{{ 'BUTTONS.CANCEL' | translate }}</button>
        <button class="primary-button popup-primary-button" form="ngForm" type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
      </div>
</div>